/* AQUON Nutrition Compare — react to the PDP flavour switch.
   The comparison card (colour + AQUON image) is rendered server-side per product.
   The PDP flavour switcher (locked bundle section) swaps flavour client-side with no
   page reload, so this section would otherwise keep the landing flavour's card.
   Here we watch the flavour selection and re-fetch THIS section for the selected
   flavour via the Section Rendering API, then update the AQUON card's background,
   auto-contrast text, and image in place. The locked bundle is only observed, never
   modified. */
(function () {
  function init() {
    var section = document.querySelector('[data-anc][data-anc-sid]');
    if (!section || section.dataset.ancFlavorBound === '1') return;
    var sid = section.getAttribute('data-anc-sid');
    var cards = document.querySelectorAll('[data-flavor-handle]');
    if (!sid || !cards.length) return;
    section.dataset.ancFlavorBound = '1';

    var VARS = ['--anc-hero-bg', '--anc-hero-text', '--anc-hero-muted', '--anc-hero-flag'];
    var busy = false;

    function activeHandle() {
      var a = document.querySelector('[data-flavor-handle].is-active');
      return a ? a.getAttribute('data-flavor-handle') : null;
    }

    var current = activeHandle(); // landing flavour is already rendered

    function apply(handle) {
      if (!handle || handle === current || busy) return;
      current = handle;
      busy = true;
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sid))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nsec = doc.querySelector('[data-anc]');
          if (!nsec) return;
          VARS.forEach(function (v) {
            var val = nsec.style.getPropertyValue(v);
            if (val) section.style.setProperty(v, val.trim());
          });
          var curMedia = section.querySelector('.anc__col--hero .anc__media');
          var nHero = doc.querySelector('.anc__col--hero');
          var nMedia = nHero && nHero.querySelector('.anc__media');
          if (curMedia && nMedia) curMedia.innerHTML = nMedia.innerHTML;
        })
        .catch(function () { current = null; })
        .then(function () {
          busy = false;
          var h = activeHandle();
          if (h && h !== current) apply(h); // catch a switch made mid-fetch
        });
    }

    // Primary: a click on any flavour card (deferred so the switcher updates state first).
    document.addEventListener('click', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('[data-flavor-handle]') : null;
      if (card) {
        var h = card.getAttribute('data-flavor-handle');
        setTimeout(function () { apply(h); }, 60);
      }
    }, true);

    // Backup: catch keyboard/programmatic changes via the active-state class.
    var scope = cards[0].closest('[data-apdp-flavor-modal]') || cards[0].parentElement || document.body;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { var h = activeHandle(); if (h) apply(h); }, 40);
    }).observe(scope, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
